import { useNavigate } from "react-router";
import { WizardStep } from "../../../consts/wizardSteps";

export type StepValidationRule = {
  stepIndex: number;
  condition: boolean;
  redirectStep: WizardStep;
};

export const useWizardNavigation = () => {
  const navigate = useNavigate();

  const createWizardUrl = (
    step: WizardStep,
    orderName?: string | string[],
  ): string => {
    const params = new URLSearchParams();

    if (orderName) {
      const orderNameValue = Array.isArray(orderName)
        ? orderName[0]
        : orderName;
      params.set("orderName", orderNameValue);
    }

    params.set("step", step);
    return `/gift/wizard?${params.toString()}`;
  };

  const navigateToStep = (
    step: WizardStep,
    orderName?: string | string[],
    replace = false,
  ) => {
    const url = createWizardUrl(step, orderName);
    navigate(url, { replace });
  };

  const validateAndNavigate = (
    rules: StepValidationRule[],
    orderName?: string | string[],
  ): boolean => {
    for (const rule of rules) {
      if (rule.condition) {
        navigateToStep(rule.redirectStep, orderName, true);
        return false;
      }
    }
    return true;
  };

  return {
    createWizardUrl,
    navigateToStep,
    validateAndNavigate,
  };
};
